import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>00:27</span> Introduction of the guest</li>
                            <li><span>02:36</span> Caya’s take on Slidebean’s Best Youtube Videos.</li>
                            <li><span>04:17</span> Caya’s experience of founding and scaling Slidebean into a Multi-Million Dollar company.</li>
                            <ul className="sub__list">
                                <li> - Accepting limitations and adapting to them throughout the journey</li>
                                <li> - Marketing strategies that have worked and failed for Slidebean</li>
                                <li> - Identifying and shifting your target audience</li>
                                <li> - Creating Products From an Idea</li>
                            </ul>
                            <li><span>10:07</span> Marketing products and services on YouTube.</li>
                            <li><span>11:30</span> Personal Branding as a CEO and its importance.</li>
                            <ul className="sub__list">
                                <li> - Taking inspiration from influencers when branding yourself as a CEO</li>
                                <li> - Thinking like a Viewer on YouTube</li>
                            </ul>
                            <li><span>16:48</span> The Struggles of Starting a Business in New York and the role of
                                acquiring funding for scaling.
                            </li>
                            <ul className="sub__list">
                                <li> - Being connected to the ecosystem</li>
                                <li> - Accelerator programs as a key to fast track growths</li>
                                <li> - Learning to strategically pivot through startup accelerators</li>
                            </ul>
                            <li><span>21:25</span> The mistakes startups make to learn from as an entrepreneur (Panelist Question).</li>
                            <ul className="sub__list">
                                <li> - The art of hustling to gain traction.</li>
                                <li> - Marketing the right way to acquire consumers through value.</li>
                                <li> - Brand positioning as a tool to improve conversion rates.</li>
                            </ul>
                            <li><span>28:52</span> The role of pitch decks in raising capital for startups (Panelist Question #2)</li>
                            <ul className="sub__list">
                                <li> - Using pitch decks to create market excitement about your service or product</li>
                            </ul>
                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;